// @ts-strict-ignore
import * as React from 'react';
import {
    ArchetypeSpecificStepRunSummaryPanelProps,
    createSRRTopBar,
    StepRunSummaryContainer,
    useSRRTopBarData,
} from '.';
import { ReleaseStepSubmissionData, ReleaseStepTakeoffData } from '@/types';
import { isPhasedReleasePaused, tryDeterminePhasedReleaseDaysToPercentageSchedule } from '@/helpers';
import { PhasedReleaseGroupWidget } from '@/components/workflowOverview/widgets/WorkflowRunPhasedReleaseWidget';

export const TakeoffStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun, appId }) => {
    const { stepData, appStoreData, isSubmitted, appStoreState, hasSelectedBuild } = useSRRTopBarData(stepRun);

    const takeoffData = stepData as ReleaseStepTakeoffData;

    const phasedRelease = appStoreData && 'phasedRelease' in appStoreData ? appStoreData.phasedRelease : null;

    const hasPhasedReleaseState = !!phasedRelease;
    const isAutomatedPhasedRollout = takeoffData.isAutomatedPhasedRollout;

    const daysToPercent =
        takeoffData.autoStagedRolloutDaysToPercent?.length ?
            takeoffData.autoStagedRolloutDaysToPercent
        :   tryDeterminePhasedReleaseDaysToPercentageSchedule(hasPhasedReleaseState, takeoffData.appStoreType, null);

    const wasAccelerated =
        phasedRelease?.isManuallyAcceleratedPhasedRollout || phasedRelease?.isRunwayAcceleratedRollout;
    const wasHalted = isPhasedReleasePaused(phasedRelease?.state);

    return (
        <div>
            <StepRunSummaryContainer
                topBar={createSRRTopBar(
                    stepRun,
                    stepData as ReleaseStepSubmissionData,
                    appStoreData,
                    isSubmitted,
                    appStoreState,
                    hasSelectedBuild,
                )}
            >
                {phasedRelease && (
                    <PhasedReleaseGroupWidget
                        appId={appId}
                        groupKey={0}
                        phasedGroupData={[
                            {
                                destinationStepConfigId: stepRun.stepId,
                                destination: stepRun.destinations[0],
                                daysToPercentSchedule: daysToPercent,
                                isAutomatedPhasedRollout: isAutomatedPhasedRollout,
                                isPaused: wasHalted,
                                isRunwayPaused: wasHalted,
                                isAccelerated: wasAccelerated,
                                isManuallyAcceleratedPhasedRollout: phasedRelease?.isManuallyAcceleratedPhasedRollout,
                                isRunwayAcceleratedRollout: phasedRelease?.isRunwayAcceleratedRollout,
                                isSuperseded: phasedRelease?.isSuperseded,
                                isCompleted: !!phasedRelease?.completedAt,
                                startDate: phasedRelease?.startDate,
                                blackoutEndsAt: phasedRelease?.blackoutEndsAt,
                                state: phasedRelease?.state,
                                phasedReleasePercent: phasedRelease?.phasedReleasePercent,
                                userFraction: phasedRelease?.userFraction,
                                dayNumber: phasedRelease?.dayNumber,
                                isOnBlackoutPeriod: phasedRelease?.isOnBlackoutPeriod,
                            },
                        ]}
                        appStoreBuildsByDestStepConfigId={{
                            [stepRun.stepId]: takeoffData.appStoreAvailableBuilds,
                        }}
                        stabilityIntegrations={[]}
                        isExpandedModule={false}
                        setExpandedModule={() => {}}
                        onlyShowAdoptionsOnExpand={false}
                        shouldHideAdoptions
                    />
                )}
            </StepRunSummaryContainer>
        </div>
    );
};
